import Row from '@components/Row';
import Text from '@components/Text';
import ArrowLineDown from '@icons/arrow/ArrowLineDown';
import {
  HTMLAttributes, ReactNode, useEffect, useRef, useState,
} from 'react';

import styles from './styles.module.scss';

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'title'>{
    title: ReactNode;
    children?: ReactNode;
    titleClassName?: string;
    handleClassName?: string;
    initialOpen?: boolean;
}

const ANIMATION_DURATION_MS = 300;

function Accordion(props: Props) {
  const {
    title, children, className, titleClassName, handleClassName,
    initialOpen, ...rest
  } = props;
  const [expand, setExpand] = useState(initialOpen || false);
  const [maxHeight, setMaxHeight] = useState<number>(0);
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current) {
      setMaxHeight(ref.current.scrollHeight);
      const timeout = setTimeout(() => {
        setIsLoad(true);
      }, ANIMATION_DURATION_MS);
      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [ref.current, children]);
  return (<div className={`${styles.container} ${className}`}
                aria-label='accordion'
                      {...rest} >
        <Row className={`${styles.handle} ${handleClassName}`}
             align='center'
             justify='space-between'
             onClick={() => setExpand(!expand)} >
            <Text size='lg'
                  as='div'
                  fontWeight='medium'
                  className={titleClassName} >
                {title}
            </Text>
            <ArrowLineDown className={`${styles.dropdown} ${expand && styles.expand}`}/>
        </Row>
        <div ref={ref}
            className={`${styles.contents} ${isLoad && styles.load}`}
             style={{ maxHeight: expand ? maxHeight : 0 }} >
            {children}
        </div>
    </div>);
}

export default Accordion;
